import { ref, computed } from 'vue';

const STORAGE_KEY = 'rc_last_seen_blog_date';

// Date of the most recently published blog post in ReadyChek Blog
export const LATEST_BLOG_DATE = '2026-08-02';

const lastSeenDate = ref(localStorage.getItem(STORAGE_KEY) || '');

export function useBlogIndicator() {
  const hasNewBlog = computed(() => {
    if (!lastSeenDate.value) return true;
    return new Date(LATEST_BLOG_DATE) > new Date(lastSeenDate.value);
  });

  const markBlogAsRead = () => {
    const now = new Date().toISOString();
    localStorage.setItem(STORAGE_KEY, now);
    lastSeenDate.value = now;
  };

  return {
    hasNewBlog,
    markBlogAsRead,
    LATEST_BLOG_DATE,
  };
}
